export default "__VITE_ASSET__CfbddLyP__"